import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import React, { useContext, useEffect, useState } from "react";
import { EstateContext } from "../../../../hooks/ContextStore";
import Loading from "../../../pages/Loading";
import FileUpload from "../Components/FileUpload";
import CreateLivestock from "./LiveStockModal/Create";
import DeleteLivestock from "./LiveStockModal/Delete";
import EditLivestock from "./LiveStockModal/Edit";
import CreatePets from "./PetsModal/Create";
import DeletePets from "./PetsModal/Delete";
import EditPets from "./PetsModal/Edit";
import ShowNoteComponent from "./ShowNoteComponent";
import { debounce } from "lodash";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import moment from "moment";
import { Create } from "@material-ui/icons";
import GreenCheckBadge from "../Components/Badge";
import SortTableHeader from "../Components/SortTableHeader";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function LiveStockRow(props) {
  const { row, client_case_id, setProperties } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.description ?? "N/A"}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.value ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.client_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left">
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <EditLivestock
                row={row}
                client_case_id={client_case_id}
                setProperties={setProperties}
              />
            </span>
          </div>
          <ShowNoteComponent row={row} />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteLivestock row={row} setProperties={setProperties} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'live-stock'} />
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Description of Asset(s) :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.description}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.value}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.client_sp}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.spouse_sp}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.net_value}
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function LiveStock() {
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [properties, setProperties] = useState([]);

  const fetch_data = () => {
    Axios.get("api/estate/asset/index/" + client_case_id + "/5")
      .then((res) => {
        setProperties(res.data.data);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div className="card-title mb-0">
        <div className="d-flex px-9 align-items-center">
          <h6>Livestock</h6>
          <div className="ml-auto">
            <CreateLivestock
              client_case_id={client_case_id}
              setProperties={setProperties}
              type={"5"}
            />
          </div>
        </div>
      </div>
      <div className="pb-10 pl-10 pr-10 pt-0">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                  Description
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Value
                </TableCell>
                {/* <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">Debt</TableCell> */}
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Client SP
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Spouse SP
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Net Value
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {properties.map((row) => (
                <LiveStockRow
                  key={row.id}
                  row={row}
                  client_case_id={client_case_id}
                  setProperties={setProperties}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

function PetsRow(props) {
  const { row, client_case_id, setLivestocks } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const response = await Axios.put(
        `api/estate/asset/assets/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setLivestocks(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500);

  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ];

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.description ?? "N/A"} {row.type_of_animal} <Position position={row.position} />
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.value ?? ""}  as of ({moment(row.value_date).format("L")})
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.client_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left">
          <ShowNoteComponent row={row} api='api/estate/asset/assets' />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeletePets row={row} setLivestocks={setLivestocks} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'pets'} />
          </div>
            <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Description of Asset(s) :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.description} onChange={(e) => handleChange('description', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.value} onChange={(e) => handleChange('value', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.client_sp} onChange={(e) => handleChange('client_sp', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.spouse_sp} onChange={(e) => handleChange('spouse_sp', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.net_value}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      <NativeSelect
                        className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                        inputProps={{
                          name: 'positions',
                        }}
                        //  defaultValue={formik.values.type}
                        onChange={(e) => handleChange('position', e.target.value)}
                        defaultValue={row.position}
                      >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        }
                      </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function Pets(props) {
  const { handleOpen } = props
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [livestocks, setLivestocks] = useState([]);
  const [loading, setLoading] = useState(false);
    const [order, setOrder]                 = useState('desc');
    const [orderBy, setOrderBy]             = useState('id');
    const headCells = [
      {
        id: 'description',
        numeric: false,
        disablePadding: true,
        label: 'Description',
      },
      {
        id: 'value',
        numeric: true,
        disablePadding: true,
        label: 'Value',
      },  
      {
        id: 'client_sp',
        numeric: true,
        disablePadding: false,
        label: 'Client SP',
      },
      {
        id: 'spouse_sp',
        numeric: true,
        disablePadding: false,
        label: 'Spouse SP',
      },
      {
        id: 'net_value',
        numeric: true,
        disablePadding: false,
        label: 'Net Value',
      },
      {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
      },
    ];
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc'; 
      var newValue = sortByProperty(livestocks, property, isAsc ? 'desc' : 'asc');
  
      setLivestocks(newValue);
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    function sortByProperty(arr, prop, order = "asc") {
      return [...arr].sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];
  
        // Handle dates
        if (Date.parse(valA) && Date.parse(valB)) {
          valA = new Date(valA);
          valB = new Date(valB);
        }
  
        if (valA < valB) return order === "asc" ? -1 : 1;
        if (valA > valB) return order === "asc" ? 1 : -1;
        return 0;
      });
    }
  const fetch_data = () => {
    setLoading(true);
    Axios.get("api/estate/asset/index/" + client_case_id + "/4")
      .then((res) => {
        setLivestocks(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>   
    <div className="d-flex px-9 align-items-center">
      <div className="ml-auto">
        <CreatePets
          client_case_id={client_case_id}
          setLivestocks={setLivestocks}
          handleOpen={handleOpen}
        />
      </div>
    </div>
      <div className="pb-10 pl-10 pr-10 pt-0">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
                      <SortTableHeader 
                        headCells={headCells} 
                        order={order}
                        orderBy={orderBy} 
                        onRequestSort={handleRequestSort}
                        rowCount={livestocks.length}/>
            <TableBody>
              {livestocks.map((row) => (
                <PetsRow
                  key={row.id}
                  row={row}
                  setLivestocks={setLivestocks}
                  client_case_id={client_case_id}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {loading && <Loading />}
      </div>
    </>
  );
}

function Livestock(props) {
  const { handleOpen } = props

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}>
        {/* <div className="card-header border-0 mt-3">
          <h3 class="card-title align-items-start flex-column align-self-center">
            <span class="card-label font-weight-bolder text-dark">
              Pets & Livestock
            </span>
            <span class="text-muted mt-0 font-weight-bold font-size-sm">
              Pets & Livestock
            </span>
          </h3>
        </div>
        <hr /> */}
        <Pets handleOpen={handleOpen}/>
      </div>
    </>
  );
}
export default Livestock;
